/**
 * Gestion des langues
 */
export default function initLanguageMenu() {
  const toggles = document.querySelectorAll('.language-toggle');
  if (!toggles.length) return;

  toggles.forEach(toggle => {
    const menu = toggle.nextElementSibling;
    if (!menu || !menu.classList.contains('language-menu')) return;

    // Clic sur le bouton
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();

      const isActive = toggle.classList.contains('active');

      // Ferme tous les autres menus
      toggles.forEach(t => {
        t.classList.remove('active');
        const m = t.nextElementSibling;
        if (m && m.classList.contains('language-menu')) {
          m.classList.remove('toggled');
        }
      });

      // Si le bouton n'était pas actif, on l'ouvre
      if (!isActive) {
        toggle.classList.add('active');
        menu.classList.add('toggled');
      }
      // Sinon, on le ferme (clic sur le bouton déjà actif)
      else {
        toggle.classList.remove('active');
        menu.classList.remove('toggled');
      }
    });

    // Fermeture quand on clique en dehors
    document.addEventListener('click', (e) => {
      if (!toggle.contains(e.target) && !menu.contains(e.target)) {
        toggle.classList.remove('active');
        menu.classList.remove('toggled');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initLanguageMenu);
